import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";

var _this = this;

import { debounce, head, unset } from 'lodash';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Form, Row, Container, ButtonGroup, Button } from "react-bootstrap";
import { connect, ReactReduxContext } from 'react-redux';
import { StateBootstrapButton as StateButton } from '../forms/elements';
import { mobilepayDuck } from "../../ducks/mobilepay";
import currency from "currency.js";
import { apiUtil, getLoyaltyStorage } from '../../util';
import axios from "axios";
import moment from 'moment';
import { AuthenticationState } from 'react-aad-msal';
var mobilepayOperations = mobilepayDuck.operations;

var MobilePaySuccess = function MobilePaySuccess(props) {
  // console.warn("MobilePaySuccess", props)
  var receipt = props.receipt,
      reset = props.reset,
      mobilepaystore = props.mobilepaystore,
      _props$paymentMethod = props.paymentMethod,
      paymentMethod = _props$paymentMethod === void 0 ? 'Unknown' : _props$paymentMethod,
      authenticationState = props.authenticationState;
  var history = useHistory(); // console.log("MobilePaySuccess", props)

  if (!receipt) {
    history.push("/mobilepay");
  }

  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h2", {
      className: "mobilePay_title"
    }, "Thank You"), /*#__PURE__*/React.createElement("h2", {
      className: "mobilepay-success"
    }, "THANK YOU FOR DINING WITH US!"), /*#__PURE__*/React.createElement("div", {
      className: "mobilepay-checkout-container"
    }, /*#__PURE__*/React.createElement(ReceiptDetails, _extends({
      index: 0,
      mobilepaystore: mobilepaystore,
      activeCategoryIndex: 1,
      defaultActive: false,
      receipt: receipt,
      paymentMethod: paymentMethod,
      authenticationState: authenticationState
    }, props))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(StateButton, {
      loading: false,
      type: "submit",
      className: "mobilepay-payment-button",
      onClick: function onClick() {
        reset();
      }
    }, "Pay for new order")));
  }.bind(_this));
};

var ReceiptDetails = function ReceiptDetails(props) {
  var index = props.index,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive = props.defaultActive,
      defaultActive = _props$defaultActive === void 0 ? false : _props$defaultActive,
      receipt = props.receipt,
      mobilepaystore = props.mobilepaystore,
      paymentMethod = props.paymentMethod,
      reset = props.reset,
      authenticationState = props.authenticationState;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
    className: "receipt_container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "location-container"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "location-info"
  }, mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.AlternateName), /*#__PURE__*/React.createElement("p", {
    className: "location-subinfo"
  }, mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.Address1, " ", mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.City, ", ", /*#__PURE__*/React.createElement("br", null), " ", mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.State, " ", mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.Zip)), /*#__PURE__*/React.createElement("h2", {
    className: "meal-heading"
  }, "Order Summary"), /*#__PURE__*/React.createElement("ul", {
    className: "mobilepay-receipt-list"
  }, /*#__PURE__*/React.createElement(CostLine, {
    cost: receipt === null || receipt === void 0 ? void 0 : receipt.NetAmountWithNoTax,
    isNegative: false,
    title: "Subtotal"
  }), /*#__PURE__*/React.createElement(CostLine, {
    cost: receipt === null || receipt === void 0 ? void 0 : receipt.Tax,
    isNegative: false,
    title: "Estimated tax"
  }), (receipt === null || receipt === void 0 ? void 0 : receipt.Gratuity) > 0.00 && /*#__PURE__*/React.createElement(CostLine, {
    cost: receipt === null || receipt === void 0 ? void 0 : receipt.Gratuity,
    isNegative: false,
    title: "Tip"
  }), /*#__PURE__*/React.createElement("li", {
    className: "mobilepay-receipt-item-total"
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", null, "".concat(currency(receipt === null || receipt === void 0 ? void 0 : receipt.GrossAmount).format())))), /*#__PURE__*/React.createElement("h2", {
    className: "takecare-title"
  }, "Take Care Now"), /*#__PURE__*/React.createElement(SendEmailReceipt, {
    mobilepaystore: mobilepaystore,
    receipt: receipt,
    paymentMethod: paymentMethod,
    authenticationState: authenticationState
  })));
};

var SendEmailReceipt = function SendEmailReceipt(props) {
  var mobilepaystore = props.mobilepaystore,
      receipt = props.receipt,
      paymentMethod = props.paymentMethod,
      authenticationState = props.authenticationState;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSending = _useState4[0],
      setIsSending = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasSentEmail = _useState6[0],
      setHasSentEmail = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isValidEmail = _useState8[0],
      setIsValidEmail = _useState8[1];

  var buttonElement = useRef(null);
  var buttonClass = hasSentEmail ? "btn cb-button-secondary mt-4" : "btn cb-button-primary mt-4";
  var buttonText = hasSentEmail ? "Send Another" : "Send Email";
  var headerText = hasSentEmail ? "Receipt sent to:" : "Would you like a copy of your receipt?";
  var loyaltyStorage = getLoyaltyStorage();
  var additionalprops = {};

  if (hasSentEmail) {
    additionalprops.readOnly = true; // additionalprops.style={pointerEvents: 'none'}
  }

  var sendEmail = function sendEmail() {
    setIsSending(true);
    var apiUrl = apiUtil.generateUrlForceVersion('marketing', 'payInAppReceipt', 'v2');
    var payload = {
      "emailAddress": email,
      // "primaryPhone":"",
      // "firstName": "",
      // "lastName": "",
      // "activeAccount": false,
      "promo_ID": "MobilePay",
      "method": paymentMethod,
      "receiptDateTime": moment(receipt.TransactionDateLocal, ["YYYY-MM-DDTHH:mm:ss"]).format('YYYYMMDD HH:mm'),
      // "lastFour": "0123",
      "processStoreAddress": mobilepaystore.Address1,
      "processStoreAddress2": mobilepaystore.Address2,
      "processStoreCity": mobilepaystore.City,
      "processStoreState": mobilepaystore.State,
      "processStoreZip": mobilepaystore.Zip.split('-')[0],
      "processStorePhone": mobilepaystore.Phone,
      "subtotal": receipt.NetAmountWithNoTax,
      "tax": receipt.Tax,
      "tip": receipt.Gratuity,
      "total": receipt.GrossAmount,
      "receiptOrderNumber": receipt.ReceiptNumber,
      // receipt.OrderCode,
      foodDetailItems: [],
      "loyaltyCustomerID": "",
      "loyaltyAccountStatus": "",
      "loyaltyPegBalance": "",
      "loyaltyPegsEarned": ""
    };
    var tmpMobilePayPegsEarned = window.sessionStorage.getItem('tmpMobilePayPegsEarned') || '';

    if (authenticationState === AuthenticationState.Authenticated) {
      var _loyaltyStorage$accou, _loyaltyStorage$accou2, _loyaltyStorage$accou3;

      Object.assign(payload, {
        loyaltyCustomerID: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.ExternalCustomerId) || '',
        loyaltyAccountStatus: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.Status) || '',
        loyaltyPegBalance: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.Balance) || '',
        loyaltyPegsEarned: Number(tmpMobilePayPegsEarned)
      });
    }

    receipt.OrderLines.map(function (orderLine) {
      payload.foodDetailItems.push({
        "foodName": orderLine.Description,
        "foodQuantity": orderLine.Quantity,
        "foodPrice": orderLine.Amount
      });
    });
    axios({
      method: 'post',
      headers: apiUtil.setHeaders(),
      data: payload,
      url: apiUrl
    }).then(function (res) {
      setEmail('');
      setIsSending(false);
      setHasSentEmail(true);

      if (buttonElement.current != null) {
        var _buttonElement$curren;

        (_buttonElement$curren = buttonElement.current) === null || _buttonElement$curren === void 0 ? void 0 : _buttonElement$curren.blur();
      }

      window.sessionStorage.removeItem('tmpMobilePayPegsEarned');
    }).catch(function (err) {
      console.log(err, "ERR");
      setIsSending(false);
    });
  };

  var resetForm = function resetForm() {
    setHasSentEmail(false);
    setIsValidEmail(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "meal-heading mt-5"
  }, headerText), /*#__PURE__*/React.createElement("input", _extends({
    className: "cb-form__input form-control cb-form__input--full " + (hasSentEmail ? 'border-0 ' : ''),
    value: email,
    id: "guest-email",
    type: "email"
  }, additionalprops, {
    placeholder: "Email Address",
    onChange: function onChange(e) {
      setEmail(e.target.value);
      var isValidEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value);
      setIsValidEmail(isValidEmail);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement("button", {
    ref: buttonElement,
    disabled: isSending || !isValidEmail,
    loading: false,
    id: "sendEmail",
    type: "submit",
    className: buttonClass,
    style: {
      width: 'unset'
    },
    onClick: function onClick() {
      !hasSentEmail ? sendEmail() : resetForm();
    }
  }, buttonText)));
};

var CostLine = function CostLine(_ref) {
  var _ref$cost = _ref.cost,
      cost = _ref$cost === void 0 ? 0 : _ref$cost,
      title = _ref.title,
      isNegative = _ref.isNegative;
  return Boolean(cost) && /*#__PURE__*/React.createElement("li", {
    className: "mobilepay-receipt-item"
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement("span", null, typeof cost === "number" ? "".concat(isNegative ? "-$" : "$").concat(cost.toFixed(2)) : cost));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: state.mobilepay.isLoading,
    check: state.mobilepay.check,
    receipt: state.mobilepay.receipt,
    code1: state.mobilepay.code1,
    code2: state.mobilepay.code2,
    payload: state.mobilepay.payload,
    gratuity: state.mobilepay.Gratuity,
    mobilepaystore: state.mobilepay.location,
    paymentMethod: state.mobilepay.paymentMethod
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    reset: function reset() {
      return dispatch(mobilepayOperations.reset());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobilePaySuccess);